export default __webpack_public_path__ + "static/logo-3c6405b839c288d018c4ff7ca99c2858.png";